export default __webpack_public_path__ + "static/media/BusinessSales.78a5621a.svg";